// Stealth Angel rebuild: small web components for the global shell. Loaded as a module where used.

/** Hides itself when its [data-dismiss] button is pressed, and stays hidden for that wording (data-key). */
class SasDismissible extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-dismissible')) return;
    const key = this.dataset.key;
    try {
      if (key && localStorage.getItem(key) === '1') this.hidden = true;
    } catch {}
    this.querySelector('[data-dismiss]')?.addEventListener('click', () => {
      this.hidden = true;
      try {
        if (key) localStorage.setItem(key, '1');
      } catch {}
    });
  }
}

/**
 * Copies the utility bar's list into the mobile menu drawer, so both show the same merchant-edited links.
 * The copy lives in a shadow root: Horizon morphs the drawer against server HTML, which would remove light-DOM children.
 */
class SasDrawerUtility extends HTMLElement {
  connectedCallback() {
    if (this.shadowRoot) return;
    const list = document.getElementById(this.dataset.source)?.querySelector('ul');
    if (!list) return;
    const copy = list.cloneNode(true);
    copy.removeAttribute('class');
    copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
    const style = document.createElement('style');
    style.textContent = `
      ul { display: grid; gap: 2px; margin: 0 0 16px; padding: 0; list-style: none; }
      a { display: inline-flex; align-items: center; gap: 6px; min-height: 40px; color: inherit; text-decoration: none; font-size: 0.9375rem; }
      a:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
      svg { width: 16px; height: 16px; }`;
    this.attachShadow({ mode: 'open' }).append(style, copy);
  }
}

// Disclosure dropdowns (details[data-sas-dropdown], for example Browse Kits): close on Escape, returning focus to
// the summary, and on a click or focus outside.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const open = event.target.closest?.('details[data-sas-dropdown][open]');
  if (!open) return;
  open.open = false;
  open.querySelector('summary')?.focus();
});
for (const type of ['click', 'focusin']) {
  document.addEventListener(type, (event) => {
    document.querySelectorAll('details[data-sas-dropdown][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
}

if (!customElements.get('sas-dismissible')) customElements.define('sas-dismissible', SasDismissible);
if (!customElements.get('sas-drawer-utility')) customElements.define('sas-drawer-utility', SasDrawerUtility);
